import { useDispatch, useSelector } from 'react-redux';
import {
  clearProductReportError,
  productReportError,
  selectProductReportError,
} from '@client/product/redux/productReportError/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export type UseProductReportErrorEffectReturnType = {
  data: ReturnType<typeof selectProductReportError>
  reportProductError: typeof productReportError,
  clearReportProductError: typeof clearProductReportError,
};

export const useProductReportErrorEffect = (): UseProductReportErrorEffectReturnType => {
  const dispatch = useDispatch();
  const data = useSelector(selectProductReportError);
  const reportProductError = bindActionCreators(productReportError, dispatch);
  const clearReportProductError = bindActionCreators(clearProductReportError, dispatch);

  return {
    data,
    reportProductError,
    clearReportProductError,
  };
};
